import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import ResetPassword from '@/features/auth/reset-password'

const searchSchema = z.object({
  email: z.string().email().optional(),
})

export const Route = createFileRoute('/(auth)/reset-password')({
  component: ResetPassword,
  validateSearch: searchSchema,
})
